// Import modules
import Logout from './Logout';

// Export modules
export default Logout;
